import styled from "styled-components";

export const DropdownIconWrapper = styled.span<{expanded: boolean}>`
  display: block;
  margin-left: 30px;
  transform:  ${props => props.expanded ? 'rotate(180deg)': 'rotate(0)'};
  transition: transform 0.5s;
`;